@import 'igws-cta.less';

:host {
  --cta-link-transform: rotate(180deg);
  --cta-link-text-margin: 0 5px 0 0;
}
